import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {useTranslate} from '@computerrock/formation-i18n';
import {useStyles, Modal, HighlightCircle} from '@ace-de/ui-components';
import {ButtonPrimary, ButtonSecondary} from '@ace-de/ui-components/buttons';
import {Icon, closeIcon, warningOutlinedIcon} from '@ace-de/ui-components/icons';
import * as contractPartnerActionTypes from '../contractPartnerActionTypes';

const DeleteCPContactDataConfirmationModal = props => {
    const {cx} = useStyles();
    const {confirmContactDataDeletion, declineContactDataDeletion, hasBackdrop} = props;
    const {createTranslateShorthand} = useTranslate();
    const translateModal = createTranslateShorthand('delete_cp_contact_data_confirmation_modal');

    return (
        <Modal
            action={(
                <Icon icon={closeIcon} onClick={declineContactDataDeletion} />
            )}
            hasBackdrop={hasBackdrop}
        >
            <div
                className={cx([
                    'global!ace-u-full-width',
                    'global!ace-u-flex',
                    'global!ace-u-flex--direction-column',
                    'global!ace-u-flex--justify-center',
                    'global!ace-u-flex--align-center',
                ])}
            >
                <HighlightCircle
                    className={cx([
                        'ace-c-highlight-circle--medium',
                        'global!ace-u-margin--bottom-32',
                        'ace-c-highlight-circle--primary',
                    ])}
                >
                    <Icon
                        icon={warningOutlinedIcon}
                        className={cx([
                            'ace-c-icon--xxl',
                            'ace-c-icon--color-highlight-pressed',
                        ])}
                    />
                </HighlightCircle>
                <p
                    className={cx([
                        'global!ace-u-margin--bottom-32',
                        'global!ace-u-typography--variant-h3',
                    ])}
                >
                    {translateModal('title.delete_contact')}
                </p>
                <p
                    className={cx([
                        'global!ace-u-margin--bottom-32',
                        'global!ace-u-typography--align-center',
                    ])}
                >
                    {translateModal('heading.delete_contact')}
                </p>
                <ButtonPrimary
                    className={cx(['global!ace-u-margin--bottom-24', 'global!ace-u-full-width'])}
                    onClick={confirmContactDataDeletion}
                >
                    {translateModal('button_label.delete')}
                </ButtonPrimary>
                <ButtonSecondary
                    className={cx('global!ace-u-full-width')}
                    onClick={declineContactDataDeletion}
                >
                    {translateModal('button_label.abort')}
                </ButtonSecondary>
            </div>
        </Modal>
    );
};

DeleteCPContactDataConfirmationModal.propTypes = {
    declineContactDataDeletion: PropTypes.func.isRequired,
    confirmContactDataDeletion: PropTypes.func.isRequired,
    hasBackdrop: PropTypes.bool,
};

DeleteCPContactDataConfirmationModal.defaultProps = {
    hasBackdrop: true,
};

const mapDispatchToProps = dispatch => ({
    declineContactDataDeletion: () => dispatch({
        type: contractPartnerActionTypes.DECLINE_DELETE_CP_CONTACT_DATA,
    }),
    confirmContactDataDeletion: () => dispatch({
        type: contractPartnerActionTypes.CONFIRM_DELETE_CP_CONTACT_DATA,
    }),
});

export default connect(null, mapDispatchToProps)(DeleteCPContactDataConfirmationModal);
